const alertsState = (state) => state.alerts

export const alertsSelectors = {
    items: (state) => alertsState(state).items,
    isLoading: (state) => alertsState(state).isLoading,
    isRefreshing: (state) => alertsState(state).isRefreshing,
    error: (state) => alertsState(state).error,
    summary: (state) => {
        const activeAlerts = alertsState(state).items.filter((alert) => alert.status === 'active')
        const total = activeAlerts.length
        const error = activeAlerts.filter((alert) => alert.level === 'error').length
        const warning = activeAlerts.filter((alert) => alert.level === 'warning').length
        const info = activeAlerts.filter((alert) => alert.level === 'info').length

        return {
            total,
            unread: total,
            byLevel: { error, warning, info },
        }
    },
}
